const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    signInShort: "Acceder",
    signUpShort: "Registro",
  },
  landing: {
    firstMessageBefore: "Mira ",
    firstMessageHighlight: "dónde han estado tus amigos",
    firstMessageAfter: " hoy.",
    secondMessageBefore: "Juega con tus amigos en el ",
    secondMessageHighlight: "mundo real.",
  },
  search: {
    placeholder: "Encuentra lo que quieras...",
    ariaLabel: "Buscar",
  },
  feed: {
    untitled: "Sin título",
    channelFallback: "Canal",
    todayMomentsSubtitle: "Descubre dónde tus amigos pasan sus mejores momentos",
    todayMomentsLabel: "Tu Momento",
    friendSpotsSection: "Los spots de tus amigos",
    spotDistancePrefix: "A",
    loadMoreSpots: "Ver más",
    nearbyExploreTitle: "Explora cerca de ti",
    nearbyTreasureHuntsTitle: "Misiones IRL",
    treasureHuntLabel: "Misión IRL",
    treasureHuntUnlockOnSite: "Misión IRL para desbloquear in situ",
    unlockOnSite: "Para desbloquear in situ",
    distanceAway: "A {{distance}}",
    mapFoundContent: "Contenido encontrado",
    mapNoExploreFound: "No se encontró ningún Explore",
    openAction: "Abrir",
    startAction: "Empezar",
    trendingNow: "Ahora mismo están en auge",
    categoriesTitle: "Categorías",
  },
  video: {
    gameAvailable: "Juego disponible en este vídeo",
    clickToPlay: "Haz clic para jugar",
    tapToPlay: "Toca para jugar",
    home: "Inicio",
    signInToLike: "Inicia sesión para dar me gusta",
    signInToComment: "Inicia sesión para comentar",
    exploreOnlyFromMap: "Los Explores solo se abren desde el mapa o su sección dedicada.",
    enableLocationForExplore: "Activa tu ubicación para ver este contenido Explore.",
    noAnswer: "Sin respuesta",
    youtubeLikesUnavailable: "Los me gusta no están disponibles en los vídeos de YouTube",
    addComment: "Añadir un comentario...",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Respuesta breve",
  },
  badges: {
    wood: "Madera",
    bronze: "Bronce",
    silver: "Plata",
    gold: "Oro",
    uranium: "Uranio",
  },
  notifications: {
    title: "Notificaciones",
    loading: "Cargando notificaciones...",
    empty: "No hay notificaciones por ahora.",
    signInRequired: "Inicia sesión para ver tus notificaciones.",
    loadError: "No se pudieron cargar las notificaciones.",
    userFallback: "Usuario",
  },
  searchFeed: {
    all: "Todo",
    spots: "Spots",
    videos: "Vídeos",
    explores: "Explores",
    treasureHunts: "Misiones IRL",
    resultsFor: "Resultados para:",
    noResults: "No se ha encontrado ningún resultado.",
    availableAt: "Disponible a {{distance}}",
    unlockOnSite: "Desbloquear in situ",
    channels: "Canales",
  },
  map: {
    filters: {
      subscriptions: "Suscripciones",
      private: "Privados",
      all: "Todo",
    },
    myPosition: "Mi posición",
    searchPlacePlaceholder: "Busca París, Montmartre...",
    geolocationUnavailable: "La geolocalización no está disponible en este dispositivo.",
    enableLocationNearby: "Autoriza la geolocalización para desbloquear contenido cercano.",
    currentPositionUnavailable: "No se puede obtener tu posición actual.",
    googleMapsLoadError: "No se pudo cargar Google Maps.",
    loadExploreSubscriptionsError: "No se pudieron cargar las suscripciones Explore.",
    loadExplorePointsError: "No se pudieron cargar los puntos Explore.",
    loadExploreMapError: "No se pudo cargar el mapa Explore.",
    loadPointDetailError: "No se pudo cargar el detalle del punto.",
    loadTreasureHuntError: "No se pudo cargar esta misión IRL.",
    noPlaceFound: "No se encontró ningún lugar para esta búsqueda.",
    placeNotFound: "Lugar no encontrado.",
    enableCurrentPositionBeforeSaving: "Activa tu posición actual antes de guardar un punto.",
    savePositionError: "No se pudo guardar esta posición.",
    positionUsableForContent: "La posición se puede usar para contenido",
    positionSaveFailed: "No se pudo guardar la posición.",
    stopTreasureHuntError: "No se pudo detener esta misión IRL.",
    gpsPointLabelPlaceholder: "Etiqueta del punto GPS",
  },
  explore: {
    signInToInteract: "Inicia sesión para interactuar con este explore.",
    likeError: "No se pudo dar like a este explore.",
    addCommentError: "No se pudo añadir el comentario.",
    addReplyError: "No se pudo añadir la respuesta.",
    likeCommentError: "No se pudo dar like a este comentario.",
    requestSent: "Solicitud enviada",
  },
  profileMenu: {
    title: "Perfil de Qubiq",
    signedOutDescription:
      "Inicia sesión para acceder a tu perfil, tus notificaciones y a las funciones de jugador y creador de Qubiq.",
    myProfile: "Mi perfil",
    editProfile: "Editar mi perfil",
    notifications: "Notificaciones",
    notificationsWithCount: "Notificaciones ({{count}})",
    friendGroups: "Grupos de amigos",
    inviteFriends: "Invitar a mis amigos",
    inviteFriendsDesktop: "Invitar a mis amigos (+20 fichas qubs)",
    createOnQubiq: "Crear en Qubiq",
    contactUs: "Contactarnos",
    creatorWelcomeTitle: "Ahora eres creador de Qubiq 💛",
    creatorWelcomeDesktop:
      "Haz clic en el botón Qubiq Studio para subir tus videos y Explores, y configurar tus juegos y misiones.",
    creatorWelcomeMobile:
      "Pulsa el botón Qubiq Studio para subir tus videos y Explores, y configurar tus juegos y misiones.",
    contactCreatorMessage:
      "Envíame un correo a damien@qubiq.tv. Te responderé lo antes posible 💛",
    legalInfo: "Información legal",
    language: "Idioma",
    languageDescription: "Elige el idioma utilizado en Qubiq.",
    cookiesAndConsent: "Cookies y consentimiento",
    manageCookies: "Gestionar mis cookies",
    openLanguageMenu: "Abrir la selección de idioma",
  },
  friendGroups: {
    title: "Grupos de amigos",
    subtitle: "Crea un grupo e invita a otros jugadores a unirse.",
    signInRequired: "Inicia sesión para acceder a tus grupos de amigos.",
    loadError: "No se pudieron cargar los grupos de amigos.",
    detailLoadError: "No se pudo cargar este grupo de amigos.",
    create: "+ Crear un grupo",
    createDialogTitle: "Crear un grupo de amigos",
    renameDialogTitle: "Cambiar el nombre del grupo",
    groupNameLabel: "Nombre del grupo",
    groupNamePlaceholder: "Ej. Team Paris",
    confirmCreate: "Crear grupo",
    confirmRename: "Guardar",
    createError: "No se pudo crear este grupo.",
    renameError: "No se pudo cambiar el nombre de este grupo.",
    duplicateNameError: "Este nombre de grupo ya existe.",
    myGroups: "Mis grupos",
    backToGroups: "Volver a los grupos",
    empty: "Todavía no tienes grupos de amigos.",
    untitledGroup: "Grupo sin nombre",
    groupCounts: "{{count}} amigo(s) · {{pending}} solicitud(es) enviada(s)",
    incomingInvitesTitle: "Invitaciones recibidas",
    invitedBy: "Invitado por {{username}}",
    accept: "Confirmar",
    refuse: "Cancelar",
    refuseInviteAction: "Rechazar",
    acceptInviteError: "No se pudo aceptar esta invitación.",
    refuseInviteError: "No se pudo rechazar esta invitación.",
    selectGroup: "Elige un grupo",
    selectGroupDescription: "Selecciona un grupo a la izquierda para ver a tus amigos y enviar nuevas invitaciones.",
    searchUsersTitle: "Añadir amigo(s)",
    searchPlayersPlaceholder: "Buscar jugadores",
    searchResults: "Resultados",
    searching: "Buscando...",
    noSearchResults: "No se encontró ningún usuario.",
    membersTitle: "Miembros del grupo",
    noMembersYet: "Todavía no hay miembros.",
    addUserDialogTitle: "¿Añadir a mi grupo de amigos?",
    addUserDialogBody: "¿Quieres enviar una invitación a {{username}}?",
    confirm: "Confirmar",
    cancel: "Cancelar",
    inviteError: "No se pudo enviar esta invitación.",
    friendStatus: "Amigo(a)",
    meLabel: "Yo",
    requestSentStatus: "Solicitud enviada",
    incomingInviteDialogTitle: "¿Unirte a este grupo de amigos?",
    incomingInviteDialogBody: "¿Quieres unirte al grupo {{groupName}}?",
    leaveGroup: "Salir del grupo",
    leaveDialogTitle: "Salir del grupo",
    leaveDialogBody: "Siempre podrás volver más tarde si alguien te invita de nuevo.",
  },
  inviteFriends: {
    pageTitle: "Invita a tus amigos",
    popupTitle: "Invita a tus amigos a Qubiq",
    popupBodyBeforeReward: "Tú y tu amigo ganáis",
    popupBodyAfterReward: "cuando se registra con tu enlace.",
    messageLabel: "Mensaje",
    copyIconLabel: "Copiar",
    rewardLine: "20 qubs para tu amigo y 20 qubs para ti",
    helper:
      "Elige contactos si tu dispositivo lo permite. Si no, Qubiq abre el menú de compartir del dispositivo o copia el mensaje.",
    cta: "Invitar a mis amigos",
    copyButton: "Copiar mensaje",
    copied: "Mensaje copiado",
    loadError: "No se pudo preparar tu enlace de invitación.",
    actionError: "No se pudo abrir la invitación.",
  },
  cookieConsent: {
    bannerTitle: "Qubiq utiliza cookies",
    bannerDescription:
      "Utilizamos rastreadores necesarios para el funcionamiento del servicio y, con tu consentimiento, cookies de medición de audiencia para comprender mejor el uso de Qubiq.",
    bannerDetails:
      "Puedes aceptar, rechazar o personalizar tus elecciones. Rechazar es tan sencillo como aceptar, y podrás modificar tus preferencias más tarde.",
    customize: "Personalizar",
    refuseAll: "Rechazar todo",
    acceptAll: "Aceptar todo",
    preferencesTitle: "Gestionar mis cookies",
    preferencesDescription:
      "Elige qué rastreadores pueden utilizarse en Qubiq. Las cookies necesarias siguen activas para permitir el inicio de sesión, la seguridad y las funciones esenciales del servicio.",
    analyticsNotice:
      "Google Analytics permanece desactivado mientras no aceptes la medición de audiencia.",
    necessaryTitle: "Cookies necesarias",
    necessaryDescription:
      "Inicio de sesión, seguridad, estabilidad de la sesión y funciones técnicas indispensables.",
    analyticsTitle: "Medición de audiencia",
    analyticsDescription:
      "Google Analytics 4 para medir el tráfico, el rendimiento y el uso global de Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Categoría reservada para futuros usos de marketing. Permanece desactivada por ahora.",
    cancel: "Cancelar",
    saveChoices: "Guardar mis elecciones",
  },
  navigation: {
    profile: "Perfil",
    home: "Inicio",
    infoAndRules: "Info y reglas",
    creatorsShow: "Nuestros creadores hacen el show",
    explore: "Explora",
    rankings: "Clasificaciones",
  },
  sidebar: {
    hangout: "Donde pasa el rato todo el mundo",
    welcomeCommunity: "Bienvenido a la comunidad",
  },
  categories: {
    entertainment: "Entretenimiento",
    quiz: "Quiz y repaso",
    science: "Divulgación científica",
    sport: "Deporte",
    esport: "Esport",
    music: "Música",
  },
  visibility: {
    public: "Pública",
    notListed: "No listada",
    private: "Privada",
  },
  ranking: {
    rankingGeneral: "Clasificación general",
    progression: "Progresión",
    rankings: "Clasificaciones",
    exploreRankings: "Clasificaciones Explore",
    players: "Jugadores",
    channels: "Canales",
    loading: "Cargando clasificación...",
    irlQuest: "Misión IRL",
    overall: "General",
    rules: {
      useCase: "Caso de uso",
      reward: "Recompensa",
      info: "Info",
      quizVictoryLabel: "Victoria Quiz",
      quizVictoryInfo: "Se otorga una sola vez por juego.",
      questionAnswerVictoryLabel: "Victoria Pregunta Respuesta",
      questionAnswerVictoryInfo: "Se otorga una sola vez por juego.",
      defeatLabel: "Derrota",
      defeatInfo: "Si hay timeout: 0 XP",
      questCompletedLabel: "Misión completada",
      questCompletedInfo: "Se otorga en cada misión completada",
      creatorGamePlayLabel: "Juego jugado en tu contenido",
      creatorGamePlayInfo: "Se otorga una sola vez por creador, juego y jugador, victoria o derrota",
      exploreLikeReceivedLabel: "Like en tu explore",
      exploreLikeReceivedInfo: "Se otorga una sola vez por usuario y por explore",
      exploreViewReceivedLabel: "Vista en tu explore",
      exploreViewReceivedInfo: "Se otorga por cada nueva sesión cualificada",
    },
  },
  profile: {
    notFound: "Perfil no encontrado.",
    loadError: "No se ha podido cargar este perfil.",
    signInToSubscribe: "Inicia sesión para suscribirte.",
    subscribeFailed: "La suscripción ha fallado.",
    deletePostFailed: "No se puede eliminar esta publicación.",
    likePostFailed: "No se puede dar me gusta a esta publicación.",
    updateQubsVisibilityFailed: "No se puede actualizar la visibilidad de qubs.",
    videos: "Vídeos",
    explores: "Explores",
    treasureHunts: "Misiones IRL",
    history: "Historial",
    wallet: "Wallet",
    noVideosWatched: "Aún no se ha visto ningún vídeo.",
    viewedDuration: "Visto {{duration}}",
  },
  bannerCounter: {
    loadError: "No se pudo cargar la wallet.",
    offline: "sin conexión",
  },
  studio: {
    explorePublicGpsRequired: "Vincula este Explore a una ubicación GPS antes de hacerlo público.",
    explorePrivateGpsRequired: "Vincula este Explore a una ubicación GPS antes de conceder acceso privado.",
    title: "Qubiq Studio",
    createAction: "Crear",
    viewChannel: "Ver mi perfil",
    subtitle: "Gestiona tu canal, sube tus vídeos y configura tus juegos",
    loading: "Cargando...",
    signInRequired: "Inicia sesión para acceder a Studio.",
    channel: "Canal",
    profile: "Editar mi perfil",
    questsAndExplores: "Misiones y Explores",
    videos: "Vídeos",
    explores: "Explores",
    exploresDescription:
      "Los Explores son vídeos cortos que puedes colocar en lugares precisos.\n\nGuarda la posición GPS de un lugar que descubras y luego esconde allí un Explore o una etapa de una misión IRL.",
    treasureHunts: "Misiones IRL",
    myChannel: "Mi canal",
    archives: "Archivos",
    statusUploading: "Subida en curso",
    statusProcessing: "Procesando",
    statusReady: "Lista",
    statusError: "Error",
    gpsPosition: "Posición GPS",
    manageGpsPoints: "Gestionar mis puntos GPS",
    manageGpsPointsDescription: "Encuentra, cambia el nombre y elimina las posiciones GPS guardadas para tus Explores.",
    backToExplores: "Volver a Explores",
    gpsPointSearchPlaceholder: "Buscar un punto GPS por nombre",
    gpsPointLabel: "Nombre del punto GPS",
    unnamedGpsPoint: "Punto GPS sin nombre",
    noGpsPoints: "Aún no hay puntos GPS guardados.",
    noGpsPointSearch: "Ningún punto GPS coincide con esta búsqueda.",
    gpsPointInUse: "Utilizado por {{count}} Explore(s)",
    gpsPointUnused: "Este punto no se utiliza en ningún Explore.",
    deleteGpsPoint: "Eliminar punto",
    gpsPointDeleteQuestion: "¿Eliminar definitivamente \"{{label}}\"?",
    gpsPointDeleteBlocked: "Este punto se utiliza en {{count}} Explore(s). Quítalo de esos Explores antes de eliminarlo.",
    loadMoreGpsPoints: "Ver más puntos",
    gpsPointsCount: "{{count}} punto(s) GPS",
    gpsMapUnavailable: "La vista previa de Maps no está disponible. Las coordenadas siguen apareciendo arriba.",
    laptop: "Portátil",
    tablet: "Tableta",
    smartphone: "Smartphone",
    durationCheckError: "No se puede comprobar la duración de este vídeo.",
    uploadFinishedProcessing: "Subida terminada. El procesamiento de calidad y la codificación están en curso.",
    verticalPreviewInfo: "Solo se muestra una vista previa vertical para los Explores.",
    saving: "Guardando...",
    save: "Guardar",
    saveGame: "Guardar juego",
    cancel: "Cancelar",
    edit: "Editar",
    editPhoto: "Editar foto",
    savingProfile: "Guardando...",
    saveProfile: "Guardar perfil",
    noGamesConfigured: "No hay ningún juego configurado.",
    noArchivedExplore: "Ningún Explore archivado por ahora.",
    noArchivedVideo: "Ningún vídeo archivado por ahora.",
    noArchivedExploreSearch: "Ningún Explore archivado coincide con esta búsqueda.",
    noArchivedVideoSearch: "Ningún vídeo archivado coincide con esta búsqueda.",
    loadingVideos: "Cargando vídeos...",
    noExploreYet: "Ningún Explore por ahora.",
    noVideoYet: "Ningún vídeo por ahora.",
    noExploreSearch: "Ningún Explore coincide con esta búsqueda.",
    noVideoSearch: "Ningún vídeo coincide con esta búsqueda.",
    noDescription: "Sin descripción.",
    untitled: "Sin título",
    confirm: "Confirmar",
    loadingAccess: "Cargando accesos...",
    noLinkedAccount: "Ninguna cuenta vinculada por ahora",
    close: "Cerrar",
    quizFirstTwoAnswersRequired: "Las dos primeras respuestas son obligatorias para {{game}}.",
    chooseCorrectAnswer: "Elige la respuesta correcta.",
    correctAnswerMustBeFilled: "La respuesta correcta debe apuntar a una respuesta rellenada.",
    shortAnswerRequired: "La respuesta correcta es obligatoria para {{game}}.",
    configureChannel: "Configurar mi canal",
    profilePhotoAlt: "Foto de perfil",
    firstName: "Nombre",
    lastName: "Apellido",
    username: "Nombre de usuario",
    bio: "Bio",
    channelName: "Nombre de tu canal",
    channelNameHelper: "Obligatorio para subir un vídeo.",
    channelDescription: "Descripción de tu canal",
    statusLabel: "Estado",
    draftStatus: "Borrador",
    publishedStatus: "Publicada",
    authorizedEmailsLabel: "Correos autorizados",
    authorizedEmailsHelper: "Un correo por línea o separados por comas.",
    titleLabel: "Título",
    categoryLabel: "Categoría",
    visibilityLabel: "Visibilidad",
    descriptionLabel: "Descripción",
    archivedVideosTab: "Vídeos",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Buscar un vídeo archivado por su título",
    archivedExploreSearchPlaceholder: "Buscar un Explore archivado por su título",
    videoSearchPlaceholder: "Buscar un vídeo por su título",
    exploreSearchPlaceholder: "Buscar un Explore por su título",
    removeFromArchives: "Quitar de los archivos",
    addVideo: "Añadir un vídeo",
    addExplore: "Añadir un Explore",
    refresh: "Actualizar",
    archive: "Archivar",
    changeThumbnail: "Cambiar miniatura",
    uploadThumbnail: "Subiendo miniatura...",
    managePrivateAccess: "Gestionar accesos privados",
    authorizedEmailsCount: "{{count}} correo(s) autorizado(s)",
    addEmails: "Añadir uno o varios correos",
    add: "Añadir",
    validate: "Validar",
    viewVideo: "Ver vídeo",
    dateLabel: "Fecha",
    viewsLabel: "Vistas",
    configureGame: "Configurar {{game}}",
    editGame: "Editar {{game}}",
    gameMoment: "Momento",
    gameStartTimecode: "Código de tiempo de inicio",
    gameEndTimecode: "Código de tiempo de fin",
    timeFormatHelper: "Usa 00:00 o 00:00:00.",
    gameStartsAt: "El juego comienza en este momento.",
    gameEndsAt: "El juego termina en este momento.",
    answerTime: "Tiempo para responder",
    secondsToAnswer: "segundos para responder",
    timecodeReference: "Referencia del código de tiempo",
    gameStartReference: "Código de tiempo de inicio del juego",
    gameEndReference: "Código de tiempo de fin del juego",
    question: "Pregunta",
    answerOne: "Respuesta 1",
    answerTwo: "Respuesta 2",
    answerThree: "Respuesta 3",
    answerFour: "Respuesta 4",
    correctAnswer: "Respuesta correcta",
    expectedAnswer: "Respuesta esperada",
    expectedAnswerHelper: "La respuesta del jugador se normalizará antes de compararla.",
    successMessage: "Mensaje de éxito",
    failureMessage: "Mensaje de error",
    globalPauseModeActive: "Configuración global activa: el modo pausa se define a nivel del vídeo",
    pauseVideoDuringGame: "Vídeo en pausa durante el juego",
    hardcoreAnswersGlobal:
      "Modo hardcore activo: las respuestas múltiples se definen globalmente",
    allowMultipleAnswers: "Permitir varias respuestas",
    hardcoreRegainGlobal:
      "Modo hardcore activo: la recuperación se define globalmente",
    enableMultipleAnswersFirst:
      "Activa primero las respuestas múltiples para permitir la recuperación",
    allowRegainEachVictory: "Permitir recuperación en cada victoria",
    globalGameConfig: "Configuración global para los juegos de este vídeo",
    hardcoreWholeVideo: "Modo hardcore en todo el vídeo",
    pauseAllGames: "Vídeo en pausa en todos los juegos de este vídeo",
    pauseCannotDisable: "La pausa del vídeo no se puede desactivar por ahora.",
    overlappingGamesWithoutPause: "Estos juegos se solaparían sin pausa:",
    allowMultipleAnswersAllHardcore:
      "Permitir varias respuestas en todos los juegos hardcore",
    allowRegainAllHardcore: "Permitir recuperación en todos los juegos hardcore",
    hardcoreGlobalAllocation:
      "El modo hardcore fuerza la asignación global. La repetición y la recuperación se configuran arriba.",
    applyToAllGames: "Aplicar a todos los juegos",
    addGame: "Añadir un juego",
    removeGameError: "No se puede eliminar el juego.",
    removeGameFailed: "No se ha podido eliminar el juego.",
    gameDisabled: "Juego desactivado.",
    disableGame: "Desactivar",
    irlQuestCardLabel: "Misión IRL",
    newTreasureHunt: "Nueva misión IRL",
    treasureHuntsLoadError: "No se pueden cargar las misiones IRL.",
    treasureHuntCreated: "Misión IRL creada.",
    treasureHuntSaved: "Misión IRL guardada.",
    treasureHuntDeleted: "Misión IRL eliminada.",
    availableExploresLoadError: "No se pueden cargar los Explores disponibles.",
    exploresAddedToQuest: "Explores añadidos a la misión IRL.",
    reorderExploresError: "No se pueden reordenar los Explores.",
    exploreRemovedFromQuest:
      "Explore retirado de la misión IRL. Volverá a aparecer en el mapa normal si es público.",
    removeExploreFromQuestError: "No se puede retirar este Explore.",
    treasureHuntThumbnailUpdated: "Miniatura de la misión actualizada.",
    configureTreasureHunt: "Selecciona una misión IRL para configurarla.",
    treasureHuntName: "Nombre de la misión",
    addExistingExplores: "Añadir Explores existentes",
    noExploreInTreasureHunt: "Todavía no hay ningún Explore en esta misión IRL.",
    noCategory: "Sin categoría",
    moveUp: "Subir",
    moveDown: "Bajar",
    remove: "Retirar",
    savingTreasureHunt: "Guardando...",
    saveTreasureHunt: "Guardar la misión",
    delete: "Eliminar",
    treasureHuntsDescription:
      "Las misiones IRL son recorridos de Explores para completar paso a paso.\n\nLos jugadores deben encontrar cada lugar y superar los juegos en cada Explore para desbloquear todas las etapas.",
    createNewExplore: "Crear un nuevo Explore",
    createTreasureHunt: "Crear una misión IRL",
    searchTreasureHunt: "Buscar una misión por su título",
    treasureHuntCount: "{{count}} explore(s)",
    noTreasureHuntYet: "Todavía no hay ninguna misión IRL.",
    noTreasureHuntSearch: "Ninguna misión IRL coincide con esta búsqueda.",
    signInToStartTreasureHunt: "Inicia sesión para empezar la misión.",
    replayable: "Rejugable",
    oneAttempt: "Un intento",
    addExistingExploresTitle: "Añadir Explores existentes",
    outsideMapWarning:
      "Los Explores ya vinculados a otra misión IRL se retirarán de su misión actual.",
    loadingAvailableExplores: "Cargando Explores disponibles...",
    noAvailableExplore: "No hay ningún Explore disponible para añadir.",
    deleteTreasureHuntTitle: "Eliminar la misión",
    deleteTreasureHuntDescription:
      "Esta acción elimina definitivamente la misión IRL, sin eliminar los Explores asociados.",
    deleting: "Eliminando...",
  },
  languageDialog: {
    title: "Idioma",
    description:
      "Elige el idioma utilizado en Qubiq. Si el idioma del navegador no está disponible, la aplicación cambia automáticamente al inglés.",
    close: "Cerrar",
  },
  legalLinks: {
    terms: "Condiciones",
    legal: "Aviso legal",
    privacy: "Privacidad",
    cookies: "Cookies",
    moderation: "Moderación",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
